import React from 'react';
import './CustomAutocomplete.scss';
import {
    Autocomplete,
    AutocompleteChangeDetails,
    AutocompleteChangeReason,
    AutocompleteFreeSoloValueMapping,
    AutocompleteRenderOptionState,
    AutocompleteValue,
    FilterOptionsState,
    Paper,
    TextField,
} from '@mui/material';
import { ArrowDown } from '../arrow-down/arrow-down';

interface CustomAutocompleteProps<T> {
    options: T[];
    getOptionLabel?(
        option: T | AutocompleteFreeSoloValueMapping<boolean | undefined>
    ): string;
    renderOption?: (
        props: React.HTMLAttributes<HTMLLIElement>,
        option: T,
        state: AutocompleteRenderOptionState
    ) => React.ReactNode;
    filterOptions?: (options: T[], state: FilterOptionsState<T>) => T[];
    value?: T;
    onChange?: (
        event: React.SyntheticEvent,
        value: AutocompleteValue<T, any, any, any>,
        reason: AutocompleteChangeReason,
        details?: AutocompleteChangeDetails<T>
    ) => void;
    defaultValue?: T;
    isValid?: boolean;
    placeholder?: string;
    onTouchEnd?: () => void;
    arrow?: React.JSX.Element;
}

export default function CustomAutocomplete<T>(
    props: CustomAutocompleteProps<T>
) {
    return (
        <div className='custom-autocomplete-root'>
            <Autocomplete
                onClose={() => props.onTouchEnd?.()}
                aria-invalid={true}
                className={`custom-autocomplete ${
                    props.isValid == false
                        ? 'custom-autocomplete-is-invalid'
                        : ''
                }`}
                autoComplete={true}
                autoHighlight={true}
                size="small"
                options={props.options}
                popupIcon={props.arrow ?? <ArrowDown />}
                value={props?.value as any}
                defaultValue={props?.defaultValue as any}
                renderInput={(params) => (
                    <TextField
                        placeholder={props.placeholder}
                        sx={{
                            ':root': {
                                paddingTop: '0',
                                paddingBottom: '0',
                            },
                        }}
                        size="small"
                        {...params}
                    />
                )}
                getOptionLabel={props.getOptionLabel}
                renderOption={props.renderOption}
                filterOptions={props.filterOptions}
                onChange={props.onChange}
                PaperComponent={(props) => (
                    <Paper
                        sx={{
                            boxShadow: '0 0.5em 1em rgba(0,0,0,.175)',
                            fontSize: '13px !important',
                            fontFamily: 'SegoeUI',
                            color: '#495057',
                        }}
                        {...props}
                    />
                )}
            />
        </div>
    );
}
